module.exports = __webpack_public_path__ + "static/media/sign-out-blue.1746e10b.svg";